import { Injectable } from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {Lista} from "../model/lista";
import {Utiles} from '../pages/utiles/utiles';
// tslint:disable-next-line:quotemark
import {tap} from "rxjs/operators";
import {ProveedorVehiculo} from "../model/proveedor-vehiculo";


@Injectable()
export class ProveedorVehiculoService {
    private api: string;
    constructor(private http: HttpClient) {
// tslint:disable-next-line:whitespace
        this.api=Utiles.api+'proveedorVehiculo';
    }
    getLista(ejemplo: ProveedorVehiculo): Observable<Lista<ProveedorVehiculo>> {
        return this.http.get<Lista<ProveedorVehiculo>>(this.api+
            '?orderBy='+encodeURI('numeroChapa')+
            '&orderDir='+encodeURI('asc')+
            '&ejemplo='+encodeURI(JSON.stringify(ejemplo))+
            '&like=S');
    }
    getTipos(): Observable<String[]> {
        return this.http.get<String[]>(this.api+'/tipos');
    }
    agregarModificarTipo(nombreActual: String, nombreNuevo: String): Observable<String[]> {
        return this.http.put<String[]>(this.api+'/tipos'+
            '?nombreNuevo='+nombreNuevo+(nombreActual!=null ? '&nombreActual='+nombreActual : ''), {})
            .pipe(
                tap(
                    data => console.log('agregado: '+data),
                    error => console.log('error: '+error)
                ));
    }

    get(id: number): Observable<ProveedorVehiculo> {
        return this.http.get<ProveedorVehiculo>(this.api+'/'+id);
    }

    agregar(p: ProveedorVehiculo): Observable<ProveedorVehiculo>{
        return this.http.post<ProveedorVehiculo>(this.api,p)
            .pipe(
                tap(
                    data => console.log('agregado: '+data),
                    error => console.log('error: '+error)
                ));
    }

    modificar(p: ProveedorVehiculo): Observable<ProveedorVehiculo>{
        return this.http.put<ProveedorVehiculo>(this.api, p)
            .pipe(
                tap(
                    data => console.log('agregado: '+data),
                    error => console.log('error: '+error)
                ));
    }

    eliminar(id: number): Observable<{}>{

        return this.http.delete(this.api+'/'+id)
            .pipe(
                tap(
                    data => console.log('eliminado'),
                    error => console.log('eliminado'),
                ));


    }
}
